import { oneLine } from 'common-tags';
import { describeFilter } from 'components/dynamic-content/copy-util';
import { tempDietaryTagMappings } from 'utils/constants';
import { CityPageCityFragment, CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

export const generateCuisinePositioningCopy = (
  cityPage: Pick<CityPageCityFragment, 'cityName' | 'stateNameShort'>,
  activeFilter?: CityPageFilterFragment
): string | null => {
  const dietaryName = activeFilter?.dietaryFilter ? tempDietaryTagMappings[activeFilter.dietaryFilter] ?? null : null;
  if (dietaryName) {
    return `You're sure to discover a ${dietaryName} cuisine you love, or something you've never tried before! Browse the cuisines below and find the perfect homemade ${dietaryName} dish or meal in ${cityPage.cityName}!`;
  }
  return `You're sure to discover a cuisine you love, or something to try for the first time! Browse the cuisines below and find the perfect homemade dish or meal!`;
};

export interface IProps {
  cityPage: Pick<CityPageCityFragment, 'cityName' | 'stateNameShort'>;
  numDishes: number;
  numCuisines: number;
  activeFilter?: CityPageFilterFragment;
}

export const generateDishesPositioningCopy: (IProps) => string = ({
  cityPage,
  numDishes,
  numCuisines,
  activeFilter,
}): string => {
  const numDishesDescription = numDishes ?? 'a smorgasbord of';
  if (activeFilter) {
    const { filterDescription } = describeFilter(activeFilter);
    return `We have ${numDishesDescription} ${filterDescription} dishes in ${cityPage.cityName}! Homemade like you remember, our ${filterDescription} dish selection in ${cityPage.cityName} is always changing, so you're sure to find something you love!`;
  }
  const cityStateName = `${cityPage.cityName}, ${cityPage.stateNameShort}`;

  return `Our Shefs offer ${numDishesDescription} diverse dishes from ${numCuisines} cuisines in ${cityPage.cityName}! Try your favorite dish, or try something new! You'll love the selection in ${cityStateName}`;
};

export const generateShefsPositioningCopy = (
  cityPage: Pick<CityPageCityFragment, 'cityName' | 'stateNameShort'>,
  activeFilter?: CityPageFilterFragment
): string => {
  if (activeFilter) {
    const { filterDescription, hasFoodOrGoods } = describeFilter(activeFilter);
    return oneLine`Picking a favorite Shef is never an easy task, but these are the best shefs for homemade ${filterDescription}${
      hasFoodOrGoods ? '' : ' food'
    } delivery in ${cityPage.cityName}, based on their reviews!`;
  }
  return `Picking a favorite Shef in ${cityPage.cityName} is never an easy task, but these are the best shefs for homemade food in ${cityPage.cityName} delivery based on their reviews!`;
};
